/* tslint:disable */
 
/**
 * PaGu Api
 * Gutschrifterstellung API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export const CreditNoteProcessAutomatedStatus = {
    Active: 'Active',
    Paused: 'Paused'
} as const;

export type CreditNoteProcessAutomatedStatus = typeof CreditNoteProcessAutomatedStatus[keyof typeof CreditNoteProcessAutomatedStatus];



